import React, { useState, useEffect } from 'react';
import Pagination from '@mui/material/Pagination';
import KnownEVData from './KnownEV/KnownEVData';
import EmbargoedData from './Embargoed/EmbargoedData';
import KnownEVColumns from './KnownEV/KnownEVColumns';
import EmbargoedColumns from './Embargoed/EmbargoedColumns';
import MarketsColumns from './Markets/MarketsColumns';
import MarketsData from './Markets/MarketsData';
import CISColumns from './CIS/CISColumns';
import CISData from './CIS/CISData';
import CMCCData from './CMCC/CMCCData';
import CMCCColumns from './CMCC/CMCCColumns';
import ISOData from './ISO/ISOData';
import ISOColumns from './ISO/ISOColumns';
import NISTData from './NIST/NISTData';
import NISTColumns from './NIST/NISTColumns';
import FedColumns from './FED/FedColumns';
import FedData from './FED/FedData';

interface IRowProps {
  hit: any;
  selectedIndex: string;
}

const ExpandedHitRow: React.FC<IRowProps> = ({ hit, selectedIndex }) => {
  const [ isExpanded, setIsExpanded ] = useState(false);
  const checkURL = (url: string) => {
    let isValid = false;
    if (url.includes('http://')) {
      isValid = true;
    }
    if (url.includes('https://')) {
      isValid = true;
    }
    if (url.includes('www.')) {
      isValid = true;
    }
    return isValid;
  };
  return (
    <div className='hb-expanded-row'>
      <div className='hb-expanded-row-header'>
        <div className='hb-row-icon' onClick={() => setIsExpanded(!isExpanded)}>
          <div className='hb-icon-frame'>
            {isExpanded ? (
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='12'
                height='8'
                viewBox='0 0 12 8'
                fill='none'
              >
                <path
                  d='M10.2982 0.841215C10.4854 0.642385 10.7193 0.542969 11 0.542969C11.2807 0.542969 11.5146 0.642385 11.7018 0.841215C11.9006 1.02835 12 1.26227 12 1.54297C12 1.82367 11.9006 2.05759 11.7018 2.24472L6.80702 7.13946C6.59649 7.34999 6.32749 7.45525 6 7.45525C5.68421 7.45525 5.41521 7.34999 5.19298 7.13946L0.298246 2.24472C0.0994153 2.05759 0 1.82367 0 1.54297C0 1.26227 0.0994153 1.02835 0.298246 0.841215C0.497076 0.642385 0.730994 0.542969 1 0.542969C1.2924 0.542969 1.52632 0.642385 1.70175 0.841215L6.59649 5.73595C6.65497 5.79443 6.56725 5.83537 6.33333 5.85876C6.11111 5.88215 5.88304 5.88215 5.64912 5.85876C5.4269 5.83537 5.34503 5.79443 5.40351 5.73595L10.2982 0.841215Z'
                  fill='var(--alternative-text-color)'
                />
              </svg>
            ) : (
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='8'
                height='12'
                viewBox='0 0 8 12'
                fill='none'
              >
                <path
                  d='M0.8421 1.70175C0.643269 1.51462 0.543853 1.2807 0.543853 1C0.543853 0.719297 0.643269 0.48538 0.8421 0.298246C1.02923 0.0994158 1.26315 -3.14415e-08 1.54385 -4.37114e-08C1.82455 -5.59813e-08 2.05847 0.0994157 2.24561 0.298246L7.14034 5.19298C7.35087 5.40351 7.45613 5.67251 7.45613 6C7.45613 6.31579 7.35087 6.58479 7.14034 6.80702L2.24561 11.7018C2.05847 11.9006 1.82456 12 1.54385 12C1.26315 12 1.02923 11.9006 0.8421 11.7018C0.64327 11.5029 0.543854 11.269 0.543854 11C0.543854 10.7076 0.643269 10.4737 0.8421 10.2982L5.73684 5.40351C5.79532 5.34503 5.83625 5.43275 5.85964 5.66667C5.88303 5.88889 5.88303 6.11696 5.85964 6.35088C5.83625 6.5731 5.79532 6.65497 5.73684 6.59649L0.8421 1.70175Z'
                  fill='var(--alternative-text-color)'
                />
              </svg>
            )}
          </div>
        </div>
        {selectedIndex === 'Known' && <KnownEVData hit={hit} />}
        {selectedIndex === 'Embargoed' && <EmbargoedData hit={hit} />}
        {selectedIndex === 'Markets' && <MarketsData hit={hit} />}
        {selectedIndex === 'CIS' && <CISData hit={hit} />}
        {selectedIndex === 'CMCC' && <CMCCData hit={hit} />}
        {selectedIndex === 'ISO' && <ISOData hit={hit} />}
        {selectedIndex === 'NIST' && <NISTData hit={hit} />}
        {selectedIndex === 'FED' && <FedData hit={hit} />}
      </div>
      {isExpanded && (
        <div className='hb-expanded-table'>
          <div className='hb-exp-table-header'>
            <div className='hb-exp-table-select-cell'>
              <div className='hb-exp-table-select-comp'>
                <div className='hb-exp-table-select-item'>
                  <div className='hb-exp-table-select-typo'>
                    Table
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width='181'
                      height='2'
                      viewBox='0 0 181 2'
                      fill='none'
                    >
                      <path
                        d='M1 1L180 0.999984'
                        stroke='url(#paint0_linear_2037_11471)'
                        strokeWidth='2'
                        strokeLinecap='round'
                      />
                      <defs>
                        <linearGradient
                          id='paint0_linear_2037_11471'
                          x1='1'
                          y1='1'
                          x2='180'
                          y2='0.999818'
                          gradientUnits='userSpaceOnUse'
                        >
                          <stop stopColor='#4CC9F0' />
                          <stop offset='0.453125' stopColor='#4895EF' />
                          <stop offset='1' stopColor='#4361EE' />
                        </linearGradient>
                      </defs>
                    </svg>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {Object.keys(hit._source).map(
            (hitInfo: string | number, i: number) => (
              <div key={i} className='hb-exp-table-result'>
                <div className='hb-exp-table-result-key'>
                  <div className='hb-exp-table-result-key-typo'>{hitInfo}</div>
                </div>
                <div className='hb-exp-table-result-value'>
                  {typeof hit._source[hitInfo] === 'string' ? (
                    <div className='hb-exp-table-result-key-typo'>
                      {hit._source[hitInfo]
                        .split(' ')
                        .map((word: any, index: any) =>
                          checkURL(word) ? (
                            <React.Fragment key={index}>
                              <a
                                href={word}
                                target='_blank'
                                rel='noreferrer'
                                className='link'
                              >
                                {word}
                              </a>{' '}
                            </React.Fragment>
                          ) : (
                            <React.Fragment key={index}>{word} </React.Fragment>
                          ),
                        )}
                    </div>
                  ) : (
                    <div className='hb-exp-table-result-key-typo'>
                      {hit._source[hitInfo]}
                    </div>
                  )}
                </div>
              </div>
            ),
          )}
        </div>
      )}
    </div>
  );
};

interface IResultsProps {
  tableData: any;
  pageNum: number;
  queryResults: any;
  formValues: any;
  setPageNum: any;
  selectedIndex: string;
  toggleModal: any;
}

const CyberHitBreakdown: React.FC<IResultsProps> = ({
  pageNum,
  toggleModal,
  selectedIndex,
  tableData,
  queryResults,
  formValues,
  setPageNum,
}) => {
  const [ pageCount, setPageCount ] = useState<number>(0);
  const totalResults = tableData.data.hits.total.value;
  const resultsPerPage = 50;

  const handlePageChange = (e: any, new_page: number) => {
    const handledPage = new_page - 1;
    setPageNum(handledPage);
    queryResults(formValues, handledPage);
  };

  useEffect(() => {
    const totalPages = Math.ceil(totalResults / resultsPerPage);
    if (totalPages >= 200) {
      setPageCount(199);
    } else if (totalPages <= 199) {
      setPageCount(totalPages);
    }
  }, [ tableData ]);

  useEffect(() => {
    setPageNum(0);
  }, [ selectedIndex ]);

  return (
    <div className='hit-breakdown-trade'>
      <div className='hb-header'>
        <div className='hb-header-text'>Search Results</div>
        <div className='hb-export' onClick={toggleModal}>
          <div className='hb-export-text'>Export Data</div>
          <div>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='none'
            >
              <path
                d='M15 6.705C14.9922 6.6361 14.9771 6.56822 14.955 6.5025V6.435C14.9189 6.35788 14.8708 6.287 14.8125 6.225L10.3125 1.725C10.2505 1.66666 10.1796 1.61856 10.1025 1.5825H10.0275C9.95457 1.5435 9.8762 1.51569 9.795 1.5H5.25C4.65326 1.5 4.08097 1.73705 3.65901 2.15901C3.23705 2.58097 3 3.15326 3 3.75V14.25C3 14.8467 3.23705 15.419 3.65901 15.841C4.08097 16.2629 4.65326 16.5 5.25 16.5H12.75C13.3467 16.5 13.919 16.2629 14.341 15.841C14.7629 15.419 15 14.8467 15 14.25V6.75C15 6.75 15 6.75 15 6.705ZM10.5 4.0575L12.4425 6H11.25C11.0511 6 10.8603 5.92098 10.7197 5.78033C10.579 5.63968 10.5 5.44891 10.5 5.25V4.0575ZM13.5 14.25C13.5 14.4489 13.421 14.6397 13.2803 14.7803C13.1397 14.921 12.9489 15 12.75 15H5.25C5.05109 15 4.86032 14.921 4.71967 14.7803C4.57902 14.6397 4.5 14.4489 4.5 14.25V3.75C4.5 3.55109 4.57902 3.36032 4.71967 3.21967C4.86032 3.07902 5.05109 3 5.25 3H9V5.25C9 5.84674 9.23705 6.41903 9.65901 6.84099C10.081 7.26295 10.6533 7.5 11.25 7.5H13.5V14.25ZM9.9675 10.7175L9.75 10.9425V9C9.75 8.80109 9.67098 8.61032 9.53033 8.46967C9.38968 8.32902 9.19891 8.25 9 8.25C8.80109 8.25 8.61032 8.32902 8.46967 8.46967C8.32902 8.61032 8.25 8.80109 8.25 9V10.9425L8.0325 10.7175C7.89127 10.5763 7.69973 10.4969 7.5 10.4969C7.30027 10.4969 7.10873 10.5763 6.9675 10.7175C6.82627 10.8587 6.74693 11.0503 6.74693 11.25C6.74693 11.4497 6.82627 11.6413 6.9675 11.7825L8.4675 13.2825C8.53883 13.3508 8.62294 13.4043 8.715 13.44C8.80478 13.4797 8.90185 13.5002 9 13.5002C9.09815 13.5002 9.19522 13.4797 9.285 13.44C9.37706 13.4043 9.46117 13.3508 9.5325 13.2825L11.0325 11.7825C11.1737 11.6413 11.2531 11.4497 11.2531 11.25C11.2531 11.0503 11.1737 10.8587 11.0325 10.7175C10.8913 10.5763 10.6997 10.4969 10.5 10.4969C10.3003 10.4969 10.1087 10.5763 9.9675 10.7175Z'
                fill='var(--alternative-text-color)'
              />
            </svg>
          </div>
        </div>
      </div>
      <div className='hb-header-col'>
        <div className='hb-space-col'></div>
        {selectedIndex === 'Known' && <KnownEVColumns />}
        {selectedIndex === 'Embargoed' && <EmbargoedColumns />}
        {selectedIndex === 'Markets' && <MarketsColumns />}
        {selectedIndex === 'CIS' && <CISColumns />}
        {selectedIndex === 'CMCC' && <CMCCColumns />}
        {selectedIndex === 'ISO' && <ISOColumns />}
        {selectedIndex === 'NIST' && <NISTColumns />}
        {selectedIndex === 'FED' && <FedColumns />}
      </div>
      {tableData.data.hits.hits.length === 0 && (
        <div className='no-hits-wrapper'>
          <div className='no-hits-text'>
            No hits found. Please try another search.
          </div>
        </div>
      )}
      <div className='hb-table'>
        {tableData.data.hits.hits.map((hit: any, index: number) => (
          <ExpandedHitRow selectedIndex={selectedIndex} key={index} hit={hit} />
        ))}
      </div>
      <div className='hb-footer'>
        <div className='hb-pagination'>
          <Pagination
            onChange={handlePageChange}
            size='large'
            count={pageCount}
            shape='rounded'
            variant='text'
            page={pageNum + 1}
          />
        </div>
      </div>
    </div>
  );
};

export default CyberHitBreakdown;
